<template>
  <div>
    <div class="navLogo">
      <div>
        <router-link to="/" class="logo"
          ><img src="@/assets/pc/logo.png" alt=""
        /></router-link>
      </div>
      <div class="right">
        <template v-for="(nav, key) in navList">
          <p @click="showModal = false">
            <router-link
              :to="`${nav.link}`"
              class="f16fff"
              v-bind:class="{ botton: nav.id == 6 }"
              >{{ nav.name }}</router-link
            >
          </p>
        </template>
        <div class="icon">
          <span class="f16fff">CN</span>
          <div class="search" @click="showModal = true"></div>
          <!-- <img src="@/assets/pc/icon-search.png" alt=""/> -->
        </div>
      </div>
    </div>
    <!-- <Search v-if="clickSearch" /> -->
    <Search :visible.sync="showModal"></Search>
  </div>
</template>
<script>
import "@/style/common.css";
import $ from "jquery";
import Search from "@/components/Search.vue";
import { GetNav } from "@/api/api";
export default {
  name: "Navbar",
  data() {
    return {
      clickSearch: false,
      showModal: false,
      navList: [],
    };
  },
  components: {
    Search,
  },
  methods: {
    // isShow() {
    //   console.log(1);
    //   this.clickSearch === false;
    //   console.log(2);
    // },
  },
  created() {
    GetNav().then((res) => {
      if (res.data.code == 1) {
        this.navList = res.data.data;
      }
    });
  },
  mounted() {
    // 监听事件
    window.addEventListener("scroll", function () {
      let t = $("body, html").scrollTop(); // 目前监听的是整个body的滚动条距离
      if (t > 0) {
        $(".navLogo").addClass("navbar-active");
      } else {
        $(".navLogo").removeClass("navbar-active");
      }
    });
  },
};
</script>
<style scoped>
.navLogo {
  width: 100%;
  height: 60px;
  background: #383a49;
  padding: 0 8.33vw;
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
  z-index: 1001;
}
/* .navLogo .f14pxfff.on {
  color: #c39969 !important;
} */
.navLogo .f14pxfff:hover {
  color: #c39969 !important;
}
.navLogo .logo img {
  width: 98px;
  height: 40px;
  object-fit: cover;
}
.navbar-active {
  position: fixed;
  top: 0;
  left: 0;
}
.f16fff.botton {
  background: #ba9153;
  padding: 10px;
  border-radius: 2px;
  box-sizing: border-box;
}
.navLogo .right {
  display: flex;
  align-items: center;
  justify-content: center;
}
.navLogo .right > * {
  margin-left: 40px;
}
.right div {
  display: flex;
  align-items: center;
  justify-content: center;
}
.right .icon .search {
  display: inline-block;
  width: 24px;
  height: 24px;
  margin-left: 20px;
  background: url(@/assets/pc/icon-search.png) no-repeat;
  cursor: pointer;
}
</style>
